import React from "react";

export const ContextCart = React.createContext();

const Storage = (cart) => {
  sessionStorage.setItem("cart", JSON.stringify(cart.length > 0 ? cart : []));
};

const ContextCartProvider = ({ children }) => {
  const [cart, setCart] = React.useState([]);

  React.useEffect(() => {
    const storage = sessionStorage.getItem("cart")
      ? JSON.parse(sessionStorage.getItem("cart"))
      : [];
    setCart(storage);
  }, []);

  const master = cart?.filter((item) => {
    return item?.master;
  });

  // const CartIncreaseCount = (count, index) => {
  //   setCart((current) => {
  //     const temp = [...current];
  //     temp[index].count = count + 1;

  //     Storage([...temp]);
  //     return [...temp];
  //   });
  // };

  // const CartDecreaseCount = (count, index) => {
  //   setCart((current) => {
  //     const temp = [...current];
  //     temp[index].count = count - 1;

  //     Storage([...temp]);
  //     return [...temp];
  //   });
  // };

  // const CartOnChangeCount = (count, index) => {
  //   setCart((current) => {
  //     const temp = [...current];
  //     temp[index].count = count;
  //     Storage([...temp]);
  //     return [...temp];
  //   });
  // };

  // const CartAddProduct = (data) => {
  //   let temp = [...cart];
  //   const findItem = temp?.findIndex((item) => item.id === data.id);
  //   if (findItem >= 0) {
  //     temp[findItem].count += data.count;
  //     setCart(temp);
  //     // Storage(temp);
  //   } else {
  //     setCart(cart.concat({ ...data }));
  //     // Storage(cart.concat({ ...data, count: 1 }));
  //   }
  // };

  // const CartOnClcikToDelete = (index) => {
  //   setCart((current) => current.filter((item, i) => i !== index));
  //   Storage(cart.filter((item, i) => i !== index));
  // };

  const contextValues = {
    // CartIncreaseCount,
    // CartDecreaseCount,
    // CartOnChangeCount,
    // CartAddProduct,
    // CartOnClcikToDelete,
    cart,
    setCart,
    Storage,
    master,
  };

  return (
    <ContextCart.Provider value={contextValues}>
      {children}
    </ContextCart.Provider>
  );
};

export default ContextCartProvider;
